import { Button, Typography, useMediaQuery, useTheme } from '@material-ui/core'
import DoneIcon from '@material-ui/icons/Done'
import { useState } from 'react'

import {
  FacilityIcon,
  FacilityName
} from '../../../../components/FacilityIcon/facilityIcons'
import { getTranslate } from '../../../../localization'
import { Entities } from '../../../../types/searchAvailability'
import useStyles from './styles/index.styles'

type Props = { searchData: Entities | undefined }

const PropertyDescription = ({ searchData }: Props) => {
  const classes = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [expanded, setExpanded] = useState(false)
  const [showAllFacility, setShowAllFacility] = useState(false)
  const maxDescriptionLength = 200
  const maxVisibleAminity = isMobile ? 6 : 18

  const facilities = searchData?.entityBasicDetails.facilities || []
  const hasMany = facilities.length > maxVisibleAminity
  const visibleFacilities = showAllFacility
    ? facilities
    : facilities.slice(0, maxVisibleAminity)
  const discription = searchData?.entityBasicDetails.description || ''
  const isLong = discription.length > maxDescriptionLength
  const displayedText = expanded
    ? discription
    : discription?.slice(0, maxDescriptionLength)
  return (
    <div className={classes.root}>
      <div className={classes.property}>
        <Typography variant="subtitle1" className={classes.secondaryTitle}>
          {getTranslate('Property Description')}
        </Typography>
        <Typography
          variant="caption"
          className={classes.greyText}
          component="span"
          style={{ display: 'inline' }}>
          {displayedText || 'No Description'}
          {isLong && !expanded && '...'}
          {isLong && (
            <Button
              variant="text"
              size="small"
              onClick={() => setExpanded(!expanded)}
              className={classes.btn}>
              {expanded
                ? getTranslate('Show Less')
                : getTranslate('Read full description')}
            </Button>
          )}
        </Typography>
        {searchData?.entityBasicDetails.facilities &&
          searchData?.entityBasicDetails.facilities.length > 0 && (
            <>
              <Typography className={classes.secondaryTitle}>
                {getTranslate('Popular Amenities')}
              </Typography>

              <div className={classes.facilitiy}>
                {visibleFacilities.map((facility, index) => (
                  <FacilityIcon
                    key={index}
                    name={facility.Name as FacilityName}
                  />
                ))}
                {hasMany && (
                  <Button
                    variant="text"
                    size="small"
                    className={classes.btn}
                    onClick={() => setShowAllFacility(!showAllFacility)}>
                    {showAllFacility
                      ? getTranslate('See All Aminities')
                      : getTranslate('Show Less Aminities')}
                  </Button>
                )}
              </div>
            </>
          )}
      </div>
      <div className={classes.policies}>
        <Typography className={classes.primaryTitle}>
          {getTranslate('Policies')}
        </Typography>
        <div className={classes.whiteDiv}>
          <div className={classes.check}>
            <DoneIcon className={classes.icon} />
            <Typography variant="caption" className={classes.greyText}>
              {`${getTranslate('Check-in')} ${
                searchData?.entityBasicDetails.checkPolicy.checkInFrom
              }`}
            </Typography>
          </div>
          <div className={classes.check}>
            <DoneIcon className={classes.icon} />
            <Typography variant="caption" className={classes.greyText}>
              {`${getTranslate('Check-out')} ${
                searchData?.entityBasicDetails.checkPolicy.checkOutFrom
              }`}
            </Typography>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PropertyDescription
